import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { UserService } from '../services/userService/user.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LoogedInAuthGuardChangeBankCard implements CanActivate {

    constructor(private userService: UserService, public router: Router) { }

    canActivate() {
        if (this.userService.isLoggedIn() == true && this.userService.getUser()?.SubscriptionType == 9) {
            this.router.navigate(['/account/myAcount']);
            return false;
        }
        else if (this.userService.isLoggedIn() == true && this.userService.getUser()?.FirstTimeInputCard) {
            this.router.navigate(['/account/registration-blocked']);
            return false;
        }
        else if (this.userService.isLoggedIn() == false) {
            this.router.navigate(['/account/myAcount']);
            return false;
        }
        return true;
    }
}